import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import styles from '~/src/lib/styles.json';
import useFetch from '~/src/overtime-lib/src/www/hooks/useFetch';
import { imgIconGoldenTicketSvg } from '../../images';
import { colorFromInt } from '../../lib';
import { Urls } from '../../lib/enums/urls';
import { Ot7Division } from '../../models/Ot7Division';
import { Ot7Team } from '../../models/Ot7Team';
import TBD from '../TBD';
import './Table.scss';

const Table = ({ showTies, isGoldenTicket = false }: { showTies: boolean; isGoldenTicket?: boolean }) => {
	const { section: divisionSlug } = useParams();

	type teamStanding = Ot7Team & {
		position: number;
		stringPosition: string;
		wins: number;
		losses: number;
		draws: number;
	};
	// type standingsResult = { ot7_event: Ot7Event; ot7_games: Ot7Game[]; ot7_team_standings: teamStanding[] };

	const standingsFetch = useFetch<teamStanding[]>({
		url: `${Urls.RestApiBaseUrl}/ot7_www/v1/standings/public/${divisionSlug}`,
		key: 'ot7_team_standings',
	});
	const ot7_team_standings = standingsFetch.result.read();

	const divisionFetch = useFetch<Ot7Division>({
		url: `${Urls.RestApiBaseUrl}/ot7_divisions/v1/public/${divisionSlug}`,
		key: 'ot7_division',
	});
	const ot7_division = divisionFetch.result.read();

	return (
		<div className="StandingsTable">
			<div className="TeamsContainer">
				<div />
				<div>Team</div>
				<div>W</div>
				<div>L</div>
				{/* <div>T</div> */}
				{ot7_team_standings?.length > 0 ? (
					ot7_team_standings.map((t, index) => (
						<Fragment key={t.id}>
							<div className="Position">{(showTies ? t.stringPosition : (index + 1).toString() ?? 0) || '-'}</div>
							<div className="Name">
								<a className="inherit" href={`/teams/${t.id}`}>
									<div className="TeamLogo" style={{ backgroundColor: colorFromInt(t.primary_color) }}>
										<img src={`${Urls.OvertimeImagesBaseUrl}/${t.logo_path}`} />
									</div>
									{t.name}
									{ot7_division.winner_ot7_team_id == t.id && (
										<div className="Winner">
											{isGoldenTicket && <img src={imgIconGoldenTicketSvg} alt="Golden Ticket" />}
											{!isGoldenTicket && (
												<FontAwesomeIcon icon={faTrophy} color={styles.COLOR.BRAND_PRIMARY} size="2x" />
											)}
										</div>
									)}
								</a>
							</div>
							<div className="Record">{t.wins ?? 0}</div>
							<div className="Record">{t.losses ?? 0}</div>
							{/* <div className="Record">{t.draws ?? 0}</div> */}
						</Fragment>
					))
				) : (
					<TBD />
				)}
			</div>
		</div>
	);
};

export default Table;
